import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/Users/baegjeong-gyu/Desktop/nuxt/moichat-nuxt/layouts/error.vue").then(m => m.default || m))
}